import React from 'react';
import PropTypes from 'prop-types';
import AttachEntityInline from './attach_entity/AttachEntityInline';

function InitialAttachEntityType({
 addExistingEntityToPitch, addNewEntityToPitch, onUnspecifiedButtonClick, sourceRequestType,
}) {
  const welcome = sourceRequestType === 'welcome';
  return (
    <div>
      <h3>
        { welcome ? (
          <> Who would you like to introduce? </>
        ) : (
          <> What would you like to submit in this pitch? </>
        )}
      </h3>
      <AttachEntityInline
        addExistingEntityToPitch={addExistingEntityToPitch}
        addNewEntityToPitch={addNewEntityToPitch}
        onUnspecifiedButtonClick={onUnspecifiedButtonClick}
        sourceRequestType={sourceRequestType}
      />
    </div>
  );
}

InitialAttachEntityType.propTypes = {
  addExistingEntityToPitch: PropTypes.func.isRequired,
  addNewEntityToPitch: PropTypes.func.isRequired,
  onUnspecifiedButtonClick: PropTypes.func.isRequired,
  sourceRequestType: PropTypes.string.isRequired,
};

export default InitialAttachEntityType;
